module.exports = __webpack_public_path__ + "img/baby-blue.4f91fdde.svg";